export default {
	ltbucksToolTipInfo: '.ltbucksToolTipInfo',
	ltbucksToolTip: '.ltbucksToolTip',
	ltbucksToolTipLink: '.ltbucksToolTipLink',
	dayPassDial: '#gaugeDayPasses',
	dayPassDialMore: '#gaugeDayPassesBuyMore',
	dayPassToolTipInfo: '.dayPassToolTipInfo',
	dayPassToolTip: '.dayPassToolTip',
	dayPassToolTipLink: '.dayPassToolTipLink'
};
